export default Object.freeze({
  CUSTOMER_JOB_DETAILS: "CustomerJobDetails",
  LOGIN_SCREEN: "Login",
  SIGNUP_SCREEN: "Signup",
  FORGOT_SCREEN: "Forgot",
  JOBS_SCREEN: "Jobs",
  KARIGAR_MY_JOBS: "KarigarMyJobs",
  CUSTOMER_JOBS_SCREEN: "CustomerJobs",
  ADD_JOB_SCREEN: "AddJob",
  ACCOUNTS_SCREEN: "Accounts",
  JOB_DETAILS: "JobDetails",
});
